import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, Clock } from "lucide-react";
import { api } from "../lib/api";

export default function BillingReturn() {
  const [status, setStatus] = useState("checking");
  const [plan, setPlan] = useState("free");

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get("/billing/status");
        setPlan(data.plan);
        if (data.plan !== "free") { setStatus("success"); return; }
      } catch (err) { console.warn("Billing-status poll mislukt, opnieuw proberen", err); }
      tries += 1;
      if (tries < 8) setTimeout(poll, 2500);
      else setStatus("pending");
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="billing-return-page">
      <div className="bg-card rounded-2xl p-10 max-w-md w-full text-center">
        {status === "checking" && (
          <>
            <Loader2 className="w-10 h-10 text-primary mx-auto mb-4 animate-spin" />
            <h1 className="font-heading font-extrabold text-2xl mb-2">Betaling controleren...</h1>
            <p className="text-sm text-muted-foreground">Een moment, we bevestigen je abonnement bij Mollie.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[#52B788] mx-auto mb-4" />
            <h1 className="font-heading font-extrabold text-2xl mb-2" data-testid="billing-success">Welkom bij {plan === "family" ? "Family" : "Pro"}! 🎉</h1>
            <p className="text-sm text-muted-foreground mb-6">Je abonnement is actief. Veel plezier met alle extra functies.</p>
          </>
        )}
        {status === "pending" && (
          <>
            <Clock className="w-12 h-12 text-amber-500 mx-auto mb-4" />
            <h1 className="font-heading font-extrabold text-2xl mb-2">Betaling in verwerking</h1>
            <p className="text-sm text-muted-foreground mb-6">Zodra de betaling bevestigd is, wordt je abonnement automatisch geactiveerd.</p>
          </>
        )}
        {status !== "checking" && (
          <Link to="/dashboard" data-testid="billing-back-dashboard" className="inline-flex rounded-full bg-primary hover:bg-[#1B4332] text-primary-foreground px-6 py-3 text-sm font-semibold transition-[background-color] duration-200">
            Naar mijn dashboard
          </Link>
        )}
      </div>
    </div>
  );
}
